import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { FileSignature, ChevronRight, Loader2, Bell } from "lucide-react";

// Compact Retainer Intelligence™ widget for the Attorney Portal dashboard.
export default function RetainerIntelWidget() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const load = () => api.get("/retainers/dashboard").then((r) => setD(r.data)).catch(() => setD(false));
    load(); const t = setInterval(load, 20000); return () => clearInterval(t);
  }, []);
  if (d === false) return null;
  if (!d) return <div className="mt-5 bg-white rounded-2xl border border-slate-100 p-5 flex justify-center"><Loader2 className="w-5 h-5 text-cobalt animate-spin" /></div>;
  const c = d.cards || {};
  const CARDS = [["Sent Today", c.sent_today], ["Pending", c.pending_signatures], ["Signed", c.signed], ["Not Opened", c.not_opened], ["Abandoned", c.abandoned]];
  const followUps = d.follow_up_needed || [];
  return (
    <div className="mt-5 bg-white rounded-2xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-5" data-testid="retainer-intel-widget">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2"><FileSignature className="w-5 h-5 text-cobalt" /><h3 className="font-heading font-semibold text-navy">Retainer Intelligence™</h3></div>
        <div className="flex items-center gap-3 text-xs text-slate-500">
          {d.avg_conversion_score != null && <span data-testid="riw-avg-conversion">Avg conversion <span className="font-bold text-cobalt">{d.avg_conversion_score}%</span></span>}
          {d.avg_engagement_score != null && <span>Engagement <span className="font-bold text-navy">{d.avg_engagement_score}%</span></span>}
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        {CARDS.map(([l, v]) => (
          <div key={l} className="rounded-xl bg-slate-50 border border-slate-100 p-3" data-testid={`riw-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <div className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">{l}</div>
            <div className="mt-0.5 text-xl font-extrabold text-navy tabular-nums">{v ?? 0}</div>
          </div>
        ))}
      </div>
      {followUps.length > 0 && (
        <div className="mt-4">
          <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide flex items-center gap-1.5 mb-2"><Bell className="w-3.5 h-3.5 text-amber-500" /> Requires Follow-Up ({followUps.length})</div>
          <div className="space-y-1">
            {followUps.slice(0, 4).map((r) => (
              <button key={r.retainer_id} onClick={() => navigate(`/intelligence/${r.case_id}`)} data-testid={`riw-followup-${r.case_id}`} className="w-full flex items-center justify-between text-left px-3 py-2 rounded-lg hover:bg-slate-50 border border-slate-100">
                <div>
                  <span className="font-mono text-[11px] text-cobalt">{r.case_number}</span>
                  <span className="text-xs text-amber-600 ml-2">{r.recommendation}</span>
                  {r.follow_up_time && <span className="text-[10px] text-slate-400 ml-1">· {r.follow_up_time}</span>}
                </div>
                <div className="flex items-center gap-1.5 text-xs text-slate-400"><span className="font-semibold text-navy">{r.score}%</span> <ChevronRight className="w-3.5 h-3.5" /></div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
